import { render } from "./StatsNumbers.vue?vue&type=template&id=d1be6d28"
import script from "./StatsNumbers.vue?vue&type=script&lang=js"
export * from "./StatsNumbers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__